<template>
  <q-page class="flex column report page-layout">
    <div class="grid-container-2-columns grid-container-spacer">
      <!-- Players table -->
      <section class="grid-container-2-columns__item--full-row">
        <q-card flat class="content-card">
          <q-card-section class="content-card__section">
            <ThePlayerTrackerTable
              :title="'Player Tracker for User: ' + userId"
              dataset="Player_Tracker_Summary"
              :timer="180000"
              v-on:loadPlayerDetails="handlePlayerSelection($event)"
              v-on:getPlayerDetails="handlePlayerSelection($event)"
              v-on:refreshPlayerDetails="handlePlayerSelection($event)"
            />
          </q-card-section>
        </q-card>
      </section>
      <!-- Transactions table -->
      <section class="grid-container-2-columns__item--full-row">
        <q-card flat class="content-card">
          <q-card-section class="content-card__section">
            <TheTransactionTable
              title="Today's Transactions:"
              dataset="Today_Transaction_Details"
              :playerId="this.selectedPlayerId"
              :timer="180000"
            />
          </q-card-section>
        </q-card>
      </section>
      <!-- Player details table -->
      <section class="grid-container-2-columns__item--full-row">
        <q-card flat class="content-card">
          <q-card-section class="content-card__section">
            <PlayerDetails :playerId="this.selectedPlayerId" />
          </q-card-section>
        </q-card>
      </section>
    </div>
  </q-page>
</template>

<script>
import ThePlayerTrackerTable from "@/components/tables/tools/ThePlayerTrackerTable.vue";
import TheTransactionTable from "@/components/tables/TheTransactionTable.vue";
import PlayerDetails from "@/views/player/PlayerDetails.vue";
export default {
  name: "PlayerTracker",
  data() {
    return {
      userId: this.$store.getters.GET_CURRENT_USER,
      selectedPlayerId: null,
    };
  },
  components: {
    ThePlayerTrackerTable,
    TheTransactionTable,
    PlayerDetails,
  },
  methods: {
    handlePlayerSelection(loadPlayerDetails) {
      this.selectedPlayerId = parseInt(loadPlayerDetails);
    },
  },
};
</script>
